import {
  IsUUID,
  IsBoolean,
  IsEnum,
  IsInt,
  IsOptional,
  IsNotEmpty,
  Min,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { ProficiencyLevel } from '../../../enums'

export class CreateProgramConceptDto {
  @ApiProperty({ description: 'Program version UUID' })
  @IsUUID()
  @IsNotEmpty()
  programVersionId!: string

  @ApiProperty({ description: 'Concept UUID' })
  @IsUUID()
  @IsNotEmpty()
  conceptId!: string

  @ApiPropertyOptional({
    description: 'Is this a core concept?',
    default: true,
  })
  @IsBoolean()
  @IsOptional()
  isCore?: boolean

  @ApiPropertyOptional({ enum: ProficiencyLevel, default: 'CONSOLIDATE' })
  @IsEnum(ProficiencyLevel)
  @IsOptional()
  expectedLevel?: ProficiencyLevel

  @ApiPropertyOptional({ description: 'Order in program' })
  @IsInt()
  @Min(0)
  @IsOptional()
  orderInProgram?: number
}
